"use client"

import {useEffect, useState} from 'react';
import {prayersRequest} from "@/utils/api/Prayers";
import {Prayers} from "@/types/Prayers";
import {useAppStore} from "@/store/AppStore";
import {useLocale} from "use-intl";

const usePrayersData = (token?: string) => {
  const locale = useLocale()
  const [data, setData] = useState<Prayers | undefined>(undefined)
  const setRefresh = useAppStore((state) => state.setRefresh);

  useEffect(() => {
    const fetchData = async (token: string) => {
      const fetched = await prayersRequest(token, locale)
      if (false === fetched) {
        setRefresh(true)
        return true
      }
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data && token) {
      fetchData(token)
    }
  }, [setRefresh, token, data, locale]);

  return data
};

export default usePrayersData;
